import {
  FaChartArea,
  FaChartBar,
  FaDesktop,
  FaHandsHelping,
  FaHeadset,
  FaHdd,
  FaLock,
  FaMoneyBill,
  FaMoneyCheck,
  FaNetworkWired,
  FaServer,
  FaUserAlt,
} from "@onemind-services-llc/react-icons-ng/fa";

export const FEATURE_CONSTANTS = { TITLE: "Why Choose CloudMyLab?" };

export const WHY_CHOOSE_CLOUDMYLAB_LIST = [
  { content: "Economy of Scale", icon: FaChartArea },
  { content: "Flexible Licensing for Multiple Vendors", icon: FaMoneyCheck },
  { content: "Technology and Vendor Agnostic Platform", icon: FaNetworkWired },
  { content: "99.9% SLA", icon: FaServer },
  { content: "Enterprise-Grade Security", icon: FaLock },
  { content: "Customized Golden Images", icon: FaDesktop },
  { content: "1:1 Instance with Zero Downtime ", icon: FaChartBar },
  { content: "24/7/365 Priority Support ", icon: FaHeadset },
  { content: "No Special Hardware or Software Needed", icon: FaHdd },
  { content: "No Expensive Hardware or Maintenance", icon: FaMoneyBill },
  { content: "Special Corporate Pricing ", icon: FaUserAlt },
  { content: "No Long Term Contract", icon: FaHandsHelping },
];
